import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const brokerLocaleModule: LocaleModule = {
  name: "broker",
  messages: { en: en, it: it },
};
